<template>
    <div class="overflow-auto h-full">
        <div class="flex flex-wrap sm:flex-nowrap items-center justify-between my-4 lg:my-8">
            <!-- title -->
            <div class="order-1 flex-grow flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"
                    class="block w-8 h-8 stroke-current text-navy">
                    <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                        <path
                            d="M12.75 15.75h3v4.5l4.5-4.5h1.494a1.506 1.506 0 0 0 1.506-1.506V2.25a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v4.5m11.625 1.125h0"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <path
                            d="M19.875 7.875a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m-7.5 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m3.75 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <circle cx="6.75" cy="13.125" r="3.375" fill="none" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2"></circle>
                        <path d="M12.75 23.25a6.054 6.054 0 0 0-12 0" fill="none" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2"></path>
                    </g>
                </svg>

                <span class="ml-2 text-navy font-bold leading-7 text-2xl">
                    Organisations
                </span>
            </div>

            <!-- Back to Organisations -->
            <div class="order-2 sm:order-3 sm:mr-3 ">
                <inertia-link
                    class="flex items-center justify-center w-7 h-7 rounded-full bg-navy hover:bg-navy-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-light"
                    :href="route('app.organisation.index')">
                    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"
                        class="block w-7 h-7 stroke-current text-white">
                        <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                            <path d="M7.501 11.997L16.501 11.997" fill="none" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.5"></path>
                            <path d="M11.251 15.747L7.501 11.997 11.251 8.247" fill="none" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.5"></path>
                        </g>
                    </svg>
                    <span class="sr-only">
                        Organisations List
                    </span>
                </inertia-link>
            </div>
        </div>

        <flash-message />

        <div class="py-8 px-5 shadow border-b border-gray-200 mt-8 bg-white">
            <form @submit.prevent="store">
                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="name">
                        Name
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="name" type="text" autocomplete="name" v-model="form.name">

                    <div class="text-red-600" v-if="form.errors.name">{{ form.errors.name }}</div>
                </div>


                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="type">
                        Type
                    </label>

                    <select
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="type" v-model="form.type">
                        <option value="">Select Option</option>
                        <option v-for="(type, key) in type_options" :value="key" :key="key">{{ type }}</option>
                    </select>
                </div>


                <div class="p-2" v-if="form.type == 'lab'">
                    <label class="block text-sm font-medium text-gray-700" for="link_lab">
                        Link Lab
                    </label>

                    <select
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="type" v-model="form.link_lab">
                        <option value="">Select Option</option>
                        <option v-for="(lab, key) in labs" :value="lab.id" :key="key">{{ lab.name }}</option>
                    </select>
                </div>

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="address_line_1">
                        Address line 1
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="address_line_1" type="text" autocomplete="address_line_1" v-model="form.address_line_1">

                    <div class="text-red-600" v-if="form.errors.address_line_1">{{ form.errors.address_line_1 }}
                    </div>
                </div>

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="address_line_2">
                        Address line 2
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="address_line_2" type="text" autocomplete="address_line_2" v-model="form.address_line_2">

                    <div class="text-red-600" v-if="form.errors.address_line_2">{{ form.errors.address_line_2 }}
                    </div>
                </div>

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="city">
                        City
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="city" type="text" autocomplete="city" v-model="form.city">

                    <div class="text-red-600" v-if="form.errors.city">{{ form.errors.city }}</div>
                </div>

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="county">
                        County
                    </label>


                    <select
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="county" v-model="form.county">
                        <option value="">Select County</option>
                        <option v-for="(county, key) in counties" :value="county" :key="key">{{ county}}</option>
                    </select>

                    <div class="text-red-600" v-if="form.errors.county">{{ form.errors.county }}</div>
                </div>

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="eircode">
                        Eircode
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="eircode" type="text" autocomplete="eircode" v-model="form.eircode">

                    <div class="text-red-600" v-if="form.errors.eircode">{{ form.errors.eircode }}</div>
                </div>

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="telephone">
                        Telephone
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="telephone" type="text" autocomplete="telephone" v-model="form.telephone">

                    <div class="text-red-600" v-if="form.errors.telephone">{{ form.errors.telephone }}</div>
                </div>

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="email">
                        Email
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="email" type="email" autocomplete="email" v-model="form.email">

                    <div class="text-red-600" v-if="form.errors.email">{{ form.errors.email }}</div>
                </div>

                <div class="p-2">
                    <label for="enabled" class="flex items-center">
                        <input
                            class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                            id="enabled" name="enabled" type="checkbox" v-model="form.enabled">
                        <span class="ml-2 text-sm font-medium text-gray-600">Active</span>
                    </label>
                </div>

                <div class="py-2 mt-10">
                    <h3 class="font-bold">Organisation Details</h3>
                </div>

                <hr class="my-1">

                <div class="p-2">
                    <label class="block text-sm font-medium text-gray-700" for="vat_no">
                        Vat No
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="text" type="text" autocomplete="vat_no" v-model="form.vat_no">

                    <div class="text-red-600" v-if="form.errors.vat_no">{{ form.errors.vat_no }}</div>
                </div>

                <div class="grid grid-cols-2">

                    <div class="col-span-2">
                        <h4 class="font-bold text-sm p-2 lg:mx-4 mt-5">Billing Options</h4>
                    </div>
                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label class="block text-sm font-medium text-gray-700" for="billing_options_lab">
                            Lab <span class="text-red-600">*</span>
                        </label>

                        <select
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="billing_options_lab" v-model="form.billing_options.lab" required>
                            <option value="" disabled>Select Option</option>
                            <option v-for="(lab, key) in billing_options.lab" :value="lab" :key="key">{{ lab }}</option>
                        </select>
                    </div>

                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label class="block text-sm font-medium text-gray-700" for="vat_no">
                            Sample Collection
                        </label>

                        <select
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="billing_options_lab" v-model="form.billing_options.collection">
                            <option value="">Select Option</option>
                            <option v-for="(collection, key) in billing_options.collection" :value="collection"
                                :key="key">{{ collection }}</option>
                        </select>
                    </div>

                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label class="block text-sm font-medium text-gray-700" for="timezone">
                            Timezone
                        </label>

                        <select
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="timezone" v-model="form.timezone">
                            <option value="">Default ({{ default_timezone }})</option>
                            <option v-for="timezone in timezones" :value="timezone" :key="timezone">{{ timezone }}</option>
                        </select>
                        <p class="mt-1 text-xs text-gray-500">Used for local dates such as the sample date sent to labs.</p>
                        <div class="text-red-600" v-if="form.errors.timezone">{{ form.errors.timezone }}</div>
                    </div>

                    <div class="col-span-2">
                        <div class="text-red-600" v-if="form.errors['billing_options.lab']">{{ form.errors['billing_options.lab'] }}</div>
                        <div class="text-red-600" v-if="form.errors.billing_options ">{{ form.errors.billing_options }}
                        </div>
                    </div>
                </div>

                <div v-show="['advisor', 'lab'].includes(form.type)">
                    <div class="py-2 px-4 mt-6">
                        <h3 class="font-bold">Contractors</h3>
                    </div>

                    <hr class="my-1">

                    <div class="p-2 lg:mx-4 mb-10">
                        <Multiselect v-model="form.contractors" :options="contractors" mode="tags" />
                    </div>
                </div>

                <div class="py-2 px-4 mt-10">
                    <h3 class="font-bold">Users</h3>
                </div>

                <div v-for="(user, index) in form.users" :key="index">
                    <hr class="my-1">

                    <div class="lg:flex w-full">
                        <div class="p-2 lg:mx-4 lg:w-1/3">
                            <label class="block text-sm font-medium text-gray-700"
                                :class="{ 'text-red-600' : form.errors['users.' + index + '.first_name']}"
                                :for="'first_name_' + index">
                                First name
                            </label>

                            <input
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                :class="{ 'border-red-600' : form.errors['users.' + index + '.first_name']}"
                                :id="'first_name_' + index" type="text" autocomplete="first_name"
                                v-model="form.users[index].first_name">
                            <div class="text-red-600" v-if="form.errors['users.' + index + '.first_name']">
                                {{ form.errors['users.' + index + '.first_name'] }}
                            </div>
                        </div>

                        <div class="p-2 lg:mx-4 lg:w-1/3">
                            <label class="block text-sm font-medium text-gray-700"
                                :class="{ 'text-red-600' : form.errors['users.' + index + '.last_name']}"
                                :for="'last_name_' + index">
                                Last name
                            </label>

                            <input
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                :class="{ 'border-red-600' : form.errors['users.' + index + '.last_name']}"
                                :id="'last_name_' + index" type="text" autocomplete="last_name_"
                                v-model="form.users[index].last_name">
                            <div class="text-red-600" v-if="form.errors['users.' + index + '.last_name']">
                                {{ form.errors['users.' + index + '.last_name'] }}
                            </div>
                        </div>

                        <div class="p-2 lg:mx-4 lg:w-1/3">
                            <label class="block text-sm font-medium text-gray-700"
                                :class="{ 'text-red-600' : form.errors['users.' + index + '.email']}"
                                :for="'email_' + index">
                                Email
                            </label>

                            <input
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                :class="{ 'border-red-600' : form.errors['users.' + index + '.email']}"
                                :id="'email_' + index" type="email" autocomplete="email"
                                v-model="form.users[index].email">
                            <div class="text-red-600" v-if="form.errors['users.' + index + '.email']">
                                {{ form.errors['users.' + index + '.email'] }}
                            </div>
                        </div>
                        <div class="w-16">
                            <div
                                v-show="form.users[index].first_name || form.users[index].last_name || form.users[index].email">
                                <a v-on:click.stop="removeUser(index)"
                                    class="inline-flex justify-center py-2 px-4 mt-8 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer"
                                    :disabled="form.processing">
                                    <svg viewBox="0 0 40 40"
                                        class="w-5 h-5 stroke-current text-navy hover:text-navy-dark "
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                                            <path d="M.75,17.25a6.753,6.753,0,0,1,9.4-6.208" fill="none"
                                                stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                            </path>
                                            <path
                                                d="M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z"
                                                fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="1.5"></path>
                                            <path
                                                d="M11.250 17.249 A6.000 6.000 0 1 0 23.250 17.249 A6.000 6.000 0 1 0 11.250 17.249 Z"
                                                fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="1.5"></path>
                                            <path d="M14.25 17.249L20.25 17.249" fill="none" stroke-linecap="round"
                                                stroke-linejoin="round" stroke-width="1.5"></path>
                                        </g>
                                    </svg>
                                    <span class="sr-only">Remove User</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex justify-start p-2 lg:mx-4">
                    <a v-on:click="addUser"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 cursor-pointer"
                        :disabled="form.processing">
                        <svg viewBox="0 0 40 40" class="w-5 h-5 stroke-current text-white"
                            xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                                <path
                                    d="M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z"
                                    fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                </path>
                                <path d="M17.25 14.25L17.25 20.25" fill="none" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="1.5"></path>
                                <path d="M14.25 17.25L20.25 17.25" fill="none" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="1.5"></path>
                                <path d="M.75,17.25a6.753,6.753,0,0,1,9.4-6.208" fill="none" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="1.5"></path>
                                <path d="M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z"
                                    fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                </path>
                            </g>
                        </svg>
                        <span class="sr-only">Add User</span>
                    </a>
                </div>

                <hr class="my-1">

                <div class="flex justify-start p-2">
                    <button type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        :disabled="form.processing">
                        Save organisation
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import _ from 'lodash'
import AppLayout from "@/Layouts/App";
import Multiselect from '@vueform/multiselect'

export default {
    layout: [AppLayout],
    components: {
        Multiselect
    },
    props: {
        contractors: Object,
        counties: Array,
        billing_options: Object,
        type_options: Object,
        labs: Object,
        timezones: { type: Array, default: () => [] },
        default_timezone: { type: String, default: "" },
    },
    setup() {
        const form = useForm({
            name: "",
            type: "advisor",
            link_lab:'',
            address_line_1: "",
            address_line_2: "",
            city: "",
            county: "",
            eircode: "",
            telephone: "",
            email: "",
            enabled: true,
            vat_no: "",
            billing_options: {
                'lab' : 'Advisor',
                'collection' : ''
            },
            timezone: "",
            contractors: [],
            users: [
                {
                    first_name: "",
                    last_name: "",
                    email: "",
                }
            ]
        })

        return { form }
    },

    methods: {
        addUser() {
            this.form.users.push({
                first_name: "",
                last_name: "",
                email: "",
            });
        },

        removeUser(index) {
            if (this.form.users.length == 1) {
                this.form.users[index].first_name = '';
                this.form.users[index].last_name = '';
                this.form.users[index].email = '';

                return;
            }
            this.form.users.splice(index, 1);
        },

        store() {
            this.form.post(route('app.organisation.store'), {
                onSuccess: () => this.form.reset(),
            })
        }
    },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
